module.exports = __webpack_public_path__ + "static/media/logo.ca7be4dd.svg";